<!-- <div  class="bs-callout bs-callout-danger"> 
    <h4>{{'FRONT_USER.ERRORS_MESSAGES.UNAUTHORIZE_USER_HEADER' | translate}}</h4> 
    <p>{{'FRONT_USER.ERRORS_MESSAGES.UNAUTHORIZE_USER' | translate}}</p>
</div> -->

<!-- ERROR -->
<div class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.UNAUTHORIZE_USER_HEADER' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.UNAUTHORIZE_USER' | translate}}</p>
        <hr>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">{{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p> 
    </div>
</div>